import { useCallback, useState } from "react";
import { Flex, Tag } from "@jsq/ds/core";
import { type Program } from "~/graphql/supergraphTypes";
import { popover, wrapper } from "./styles_vanilla.css";

export type CaseProgram = Pick<Program, "id" | "name">;

export type Props = {
  casePrograms: CaseProgram[];
};

export const ComplianceProgramDisplay = ({ casePrograms }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const label =
    casePrograms.length === 1
      ? casePrograms[0].name
      : `Multiple programs (${casePrograms.length})`;

  const handleMouseEnter = useCallback(() => setIsOpen(true), []);
  const handleMouseLeave = useCallback(() => setIsOpen(false), []);

  return (
    <div className={wrapper} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Tag data-testid="compliance-program-value" label={label} />
      {isOpen && casePrograms.length > 1 && (
        <div className={popover} data-testid="compliance-program-popover">
          <Flex flexDirection="column" alignItems="flex-start" gap={4}>
            {casePrograms.map((program) => (
              <Tag key={program.id} label={program.name} />
            ))}
          </Flex>
        </div>
      )}
    </div>
  );
};
